/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/**
 * Show the Rimix SAVE badge below the main product title without reparenting
 * the app-owned badge. A persistent display copy prevents variant changes from
 * briefly removing and re-inserting the visible badge.
 */
(function () {
    var badgeId = 'rm-product-badge-6969f7a472ea02faf95c8c5c';
    var sourceSelector = '.product-gallery__carousel .rm-product-badge-wrap.rm-badge-' + badgeId.replace('rm-product-badge-', '');
    var targetSelector = '.rm-product-badge-wrap.rm-product-badge-in-product-page[data-position="below_title"]';
    var slotClass = 'karuno-save-badge-slot';
    var queued = false;
    var settleTimer = null;

    function findProductMeta() {
        return document.querySelector('.product-meta');
    }

    function findSourceBadge(meta) {
        var gallerySource = document.querySelector(sourceSelector);
        var galleryBadge = gallerySource && gallerySource.querySelector('#' + badgeId);

        if (galleryBadge) {
            return galleryBadge;
        }

        var candidates = meta ? meta.querySelectorAll('#' + badgeId) : [];

        for (var index = 0; index < candidates.length; index += 1) {
            if (!candidates[index].closest('.' + slotClass)) {
                return candidates[index];
            }
        }

        return null;
    }

    function ensureStyles() {
        if (document.getElementById('karuno-save-badge-smooth-styles')) {
            return;
        }

        var style = document.createElement('style');
        style.id = 'karuno-save-badge-smooth-styles';
        style.textContent =
            '.template-product .' + slotClass + '{display:none;margin:8px 0 4px;min-height:31px;}' +
            '.template-product .' + slotClass + '.is-visible{display:block;}' +
            '.template-product .' + slotClass + ',.template-product .' + slotClass + ' *{' +
            'animation:none!important;transition:none!important;}';

        document.head.appendChild(style);
    }

    function ensureSlot(meta) {
        var slot = meta.querySelector('.' + slotClass);

        if (slot) {
            return slot;
        }

        slot = document.createElement('div');
        slot.className = slotClass;
        slot.setAttribute('aria-live', 'polite');

        var productTitle = meta.querySelector('.product-meta__title');

        if (productTitle) {
            productTitle.insertAdjacentElement('afterend', slot);
        } else {
            var appTarget = meta.querySelector(targetSelector);

            if (appTarget) {
                appTarget.insertAdjacentElement('afterend', slot);
            } else {
                var priceArea = meta.querySelector('.product-meta__price-list-container, .price-list');

                if (priceArea) {
                    priceArea.insertAdjacentElement('afterend', slot);
                } else {
                    meta.appendChild(slot);
                }
            }
        }

        return slot;
    }

    function copyBadgeInPlace(sourceBadge, slot) {
        var sourceWrapper = sourceBadge.closest('.rm-product-badge-wrap');
        var sourceClasses = sourceWrapper ? sourceWrapper.className.split(/\s+/) : [];
        var badgeContextClass = '';
        var slotClasses = slot.className.split(/\s+/);

        for (var slotIndex = 0; slotIndex < slotClasses.length; slotIndex += 1) {
            if (slotClasses[slotIndex].indexOf('rm-badge-') === 0) {
                slot.classList.remove(slotClasses[slotIndex]);
            }
        }

        for (var sourceIndex = 0; sourceIndex < sourceClasses.length; sourceIndex += 1) {
            if (sourceClasses[sourceIndex].indexOf('rm-badge-') === 0) {
                badgeContextClass = sourceClasses[sourceIndex];
                slot.classList.add(badgeContextClass);
                break;
            }
        }

        var signature = badgeContextClass + '|' + sourceBadge.outerHTML;

        if (slot.getAttribute('data-badge-signature') === signature) {
            return;
        }

        var displayBadge = slot.querySelector('#' + badgeId);

        if (!displayBadge) {
            displayBadge = sourceBadge.cloneNode(true);
            slot.appendChild(displayBadge);
        } else {
            while (displayBadge.attributes.length) {
                displayBadge.removeAttribute(displayBadge.attributes[0].name);
            }

            for (var index = 0; index < sourceBadge.attributes.length; index += 1) {
                var attribute = sourceBadge.attributes[index];
                displayBadge.setAttribute(attribute.name, attribute.value);
            }

            displayBadge.innerHTML = sourceBadge.innerHTML;
        }

        displayBadge.style.setProperty('position', 'static', 'important');
        displayBadge.style.setProperty('inset', 'auto', 'important');
        displayBadge.style.setProperty('transform', 'none', 'important');
        displayBadge.style.setProperty('display', 'inline-block', 'important');
        displayBadge.style.setProperty('margin', '0', 'important');

        var visualSelectors = ['.rm-pattern-badge', '.rm-pattern-badge-1', '.rm-pattern-badge-label'];
        var visualProperties = [
            'display', 'background', 'background-color', 'color', 'border', 'border-radius',
            'padding', 'margin', 'box-shadow', 'font-size', 'font-weight', 'line-height',
            'letter-spacing', 'align-items', 'justify-content', 'min-width', 'min-height'
        ];

        for (var visualIndex = 0; visualIndex < visualSelectors.length; visualIndex += 1) {
            var sourceVisual = sourceBadge.querySelector(visualSelectors[visualIndex]);
            var displayVisual = displayBadge.querySelector(visualSelectors[visualIndex]);

            if (!sourceVisual || !displayVisual) {
                continue;
            }

            var computedVisual = window.getComputedStyle(sourceVisual);

            for (var propertyIndex = 0; propertyIndex < visualProperties.length; propertyIndex += 1) {
                var propertyName = visualProperties[propertyIndex];
                displayVisual.style.setProperty(propertyName, computedVisual.getPropertyValue(propertyName), 'important');
            }
        }

        slot.setAttribute('data-badge-signature', signature);
        slot.classList.add('is-visible');
    }

    function hideAppCopies(meta, sourceBadge) {
        var galleryWrapper = sourceBadge && sourceBadge.closest('.product-gallery .rm-product-badge-wrap');

        if (galleryWrapper && galleryWrapper.style.display !== 'none') {
            galleryWrapper.style.setProperty('display', 'none', 'important');
        }

        var appTargets = meta.querySelectorAll('.rm-product-badge-wrap.rm-product-badge-in-product-page');

        for (var index = 0; index < appTargets.length; index += 1) {
            var target = appTargets[index];

            if (!target.classList.contains(slotClass) && target.querySelector('#' + badgeId) && target.style.display !== 'none') {
                target.style.setProperty('display', 'none', 'important');
            }
        }
    }

    function syncSaveBadge() {
        var meta = findProductMeta();

        if (!meta) {
            return;
        }

        ensureStyles();

        var slot = ensureSlot(meta);
        var sourceBadge = findSourceBadge(meta);

        if (sourceBadge) {
            copyBadgeInPlace(sourceBadge, slot);
            hideAppCopies(meta, sourceBadge);
        }
    }

    function queueSync() {
        if (!queued) {
            queued = true;

            window.requestAnimationFrame(function () {
                queued = false;
                syncSaveBadge();
            });
        }

        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(syncSaveBadge, 120);
    }

    function initializeSaveBadgePosition() {
        if (!document.body || !document.body.classList.contains('template-product')) {
            return;
        }

        syncSaveBadge();

        var observer = new MutationObserver(function (mutations) {
            var shouldSync = false;

            for (var index = 0; index < mutations.length; index += 1) {
                var target = mutations[index].target;

                if (!(target.nodeType === 1 && target.closest && target.closest('.' + slotClass))) {
                    shouldSync = true;
                    break;
                }
            }

            if (shouldSync) {
                queueSync();
            }
        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true
        });

        document.addEventListener('variant:changed', queueSync);
        window.addEventListener('pageshow', queueSync);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeSaveBadgePosition, { once: true });
    } else {
        initializeSaveBadgePosition();
    }
}());

/**
 * Let Variant Gallery images follow each source image's own aspect ratio.
 * Keep the media area full-width and let Warehouse's native adaptive-height
 * carousel resize itself when a different image or variant is selected.
 */
(function () {
    if (document.getElementById('karuno-variant-gallery-sizing')) {
        return;
    }

    var style = document.createElement('style');
    style.id = 'karuno-variant-gallery-sizing';
    style.textContent =
        '.template-product .product-gallery__carousel[data-variant-gallery-ids]:not([data-variant-gallery-ids=""]) .product-gallery__carousel-item[data-media-type="image"] .product-gallery__size-limiter{max-width:none!important;width:100%!important;}';

    document.head.appendChild(style);
}());

/**
 * Preload the first image for each Variant Gallery after the initial page load.
 * This keeps the first color/size switch responsive without downloading every
 * gallery image up front.
 */
(function karunoPreloadVariantGalleryCovers() {
    function preloadCovers() {
        var gallery = document.querySelector('.product-gallery__carousel[data-variant-gallery-ids]:not([data-variant-gallery-ids=""])');

        if (!gallery) {
            return;
        }

        var variantIds = (gallery.getAttribute('data-variant-gallery-ids') || '').split(',').filter(Boolean);
        var cells = gallery.querySelectorAll('.product-gallery__carousel-item[data-variant-ids]');
        var preloadedSources = {};

        for (var variantIndex = 0; variantIndex < variantIds.length; variantIndex += 1) {
            var variantId = variantIds[variantIndex];

            for (var cellIndex = 0; cellIndex < cells.length; cellIndex += 1) {
                var cellVariantIds = (cells[cellIndex].getAttribute('data-variant-ids') || '').split(',').filter(Boolean);

                if (cellVariantIds.indexOf(variantId) === -1) {
                    continue;
                }

                var image = cells[cellIndex].querySelector('img');

                if (image) {
                    var source = image.currentSrc || image.src;

                    if (!preloadedSources[source]) {
                        preloadedSources[source] = true;
                        image.loading = 'eager';

                        if (image.decode) {
                            image.decode().catch(function () {});
                        }
                    }
                }

                break;
            }
        }
    }

    function schedulePreload() {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(preloadCovers, { timeout: 1000 });
        } else {
            window.setTimeout(preloadCovers, 250);
        }
    }

    if (document.readyState === 'complete') {
        schedulePreload();
    } else {
        window.addEventListener('load', schedulePreload, { once: true });
    }
}());

/**
 * Keep the desktop product information card aligned with the gallery card.
 * The theme's default sticky offset is larger than the product section gap.
 */
(function () {
    if (document.getElementById('karuno-product-card-alignment')) {
        return;
    }

    var style = document.createElement('style');
    style.id = 'karuno-product-card-alignment';
    style.textContent =
        '@media screen and (min-width: 1000px){' +
        '.template-product .product-block-list__item--info > .card--sticky{' +
        'top:calc(var(--header-height, 0px) + 15px)!important;' +
        '}' +
        '}';

    document.head.appendChild(style);
}());


(function () {
  if (document.getElementById('karuno-product-typography-match')) {
    return;
  }

  var style = document.createElement('style');
  style.id = 'karuno-product-typography-match';
  style.textContent =
    '.template-product .product-block-list__item--info{' +
      'font-size:14px;' +
      'line-height:26.18px;' +
    '}' +
    '.template-product .product-meta__title{' +
      'font-size:27px!important;' +
      'line-height:38.61px!important;' +
    '}' +
    '.template-product .product-meta__vendor,' +
    '.template-product .product-meta__sku{' +
      'font-size:12px!important;' +
      'line-height:22.44px!important;' +
    '}' +
    '.template-product .product-form__option-name,' +
    '.template-product .product-form__info-title{' +
      'font-size:14px!important;' +
      'line-height:26.18px!important;' +
    '}' +
    '.template-product .product-form__inventory{' +
      'font-size:14px!important;' +
      'line-height:16.8px!important;' +
    '}' +
    '.template-product .product-block-list__item--info .price:not(.price--compare){' +
      'font-size:23px!important;' +
      'line-height:23px!important;' +
    '}' +
    '.template-product .product-form__add-button{' +
      'font-size:14px!important;' +
      'line-height:48px!important;' +
    '}' +
    '@media screen and (max-width: 640px){' +
      '.template-product .product-block-list__item--info{' +
        'font-size:13px;' +
        'line-height:24.31px;' +
      '}' +
      '.template-product .product-meta__title{' +
        'font-size:23px!important;' +
        'line-height:33.35px!important;' +
      '}' +
      '.template-product .product-form__option-name,' +
      '.template-product .product-form__info-title{' +
        'font-size:13px!important;' +
        'line-height:24.31px!important;' +
      '}' +
      '.template-product .product-form__inventory{' +
        'font-size:13px!important;' +
        'line-height:15.6px!important;' +
      '}' +
    '}';

  document.head.appendChild(style);
}());


(function () {
  if (document.getElementById('karuno-zh-barlow-font')) {
    return;
  }

  var style = document.createElement('style');
  style.id = 'karuno-zh-barlow-font';
  style.textContent =
    '@font-face{' +
      'font-family:Barlow;font-weight:500;font-style:normal;font-display:swap;' +
      'src:url("/cdn/fonts/barlow/barlow_n5.a193a1990790eba0cc5cca569d23799830e90f07.woff2") format("woff2"),' +
      'url("/cdn/fonts/barlow/barlow_n5.ae31c82169b1dc0715609b8cc6a610b917808358.woff") format("woff");' +
    '}' +
    '@font-face{' +
      'font-family:Barlow;font-weight:600;font-style:normal;font-display:swap;' +
      'src:url("/cdn/fonts/barlow/barlow_n6.329f582a81f63f125e63c20a5a80ae9477df68e1.woff2") format("woff2"),' +
      'url("/cdn/fonts/barlow/barlow_n6.0163402e36247bcb8b02716880d0b39568412e9e.woff") format("woff");' +
    '}' +
    '@font-face{' +
      'font-family:Barlow;font-weight:700;font-style:normal;font-display:swap;' +
      'src:url("/cdn/fonts/barlow/barlow_n7.691d1d11f150e857dcbc1c10ef03d825bc378d81.woff2") format("woff2"),' +
      'url("/cdn/fonts/barlow/barlow_n7.4fdbb1cb7da0e2c2f88492243ffa2b4f91924840.woff") format("woff");' +
    '}' +
    '@font-face{' +
      'font-family:Barlow;font-weight:500;font-style:italic;font-display:swap;' +
      'src:url("/cdn/fonts/barlow/barlow_i5.714d58286997b65cd479af615cfa9bb0a117a573.woff2") format("woff2"),' +
      'url("/cdn/fonts/barlow/barlow_i5.0120f77e6447d3b5df4bbec8ad8c2d029d87fb21.woff") format("woff");' +
    '}' +
    '@font-face{' +
      'font-family:Barlow;font-weight:600;font-style:italic;font-display:swap;' +
      'src:url("/cdn/fonts/barlow/barlow_i6.5a22bd20fb27bad4d7674cc6e666fb9c77d813bb.woff2") format("woff2"),' +
      'url("/cdn/fonts/barlow/barlow_i6.1c8787fcb59f3add01a87f21b38c7ef797e3b3a1.woff") format("woff");' +
    '}' +
    '@font-face{' +
      'font-family:Barlow;font-weight:700;font-style:italic;font-display:swap;' +
      'src:url("/cdn/fonts/barlow/barlow_i7.50e19d6cc2ba5146fa437a5a7443c76d5d730103.woff2") format("woff2"),' +
      'url("/cdn/fonts/barlow/barlow_i7.47e9f98f1b094d912e6fd631cc3fe93d9f40964f.woff") format("woff");' +
    '}' +
    'html[lang="zh-TW"]{' +
      '--heading-font-family:Barlow,sans-serif!important;' +
      '--heading-font-weight:600;' +
      '--text-font-family:Barlow,sans-serif!important;' +
      '--text-font-weight:500;' +
      '--text-font-bolder-weight:600;' +
    '}' +
    'html[lang="zh-TW"] body,' +
    'html[lang="zh-TW"] button,' +
    'html[lang="zh-TW"] input,' +
    'html[lang="zh-TW"] select,' +
    'html[lang="zh-TW"] textarea{' +
      'font-family:Barlow,sans-serif!important;' +
    '}' +
    'html[lang="zh-TW"] .heading,' +
    'html[lang="zh-TW"] h1,' +
    'html[lang="zh-TW"] h2,' +
    'html[lang="zh-TW"] h3,' +
    'html[lang="zh-TW"] h4,' +
    'html[lang="zh-TW"] h5,' +
    'html[lang="zh-TW"] h6{' +
      'font-family:Barlow,sans-serif!important;' +
      'font-weight:600;' +
    '}';

  document.head.appendChild(style);
}());


(function () {
  if (document.getElementById('karuno-ja-hikers-font')) {
    return;
  }

  var style = document.createElement('style');
  style.id = 'karuno-ja-hikers-font';
  style.textContent =
    'html[lang="ja"]{' +
      '--heading-font-family:"ヒラギノ角ゴ Pro W6","ヒラギノ角ゴ W6","Hiragino Kaku Gothic Pro W6",YuGothic,"游ゴシック",Meiryo,"メイリオ","ＭＳ Ｐゴシック","MS PGothic",sans-serif!important;' +
      '--heading-font-weight:700;' +
      '--text-font-family:"Hiragino Sans W3","Hiragino Kaku Gothic ProN","ヒラギノ角ゴ ProN W3",YuGothic,"游ゴシック",Meiryo,"メイリオ","ＭＳ Ｐゴシック","MS PGothic",sans-serif!important;' +
      '--text-font-weight:400;' +
      '--text-font-bolder-weight:700;' +
    '}' +
    'html[lang="ja"] body,' +
    'html[lang="ja"] input,' +
    'html[lang="ja"] select,' +
    'html[lang="ja"] textarea{' +
      'font-family:"Hiragino Sans W3","Hiragino Kaku Gothic ProN","ヒラギノ角ゴ ProN W3",YuGothic,"游ゴシック",Meiryo,"メイリオ","ＭＳ Ｐゴシック","MS PGothic",sans-serif!important;' +
      'font-weight:400;' +
    '}' +
    'html[lang="ja"] .heading,' +
    'html[lang="ja"] h1,' +
    'html[lang="ja"] h2,' +
    'html[lang="ja"] h3,' +
    'html[lang="ja"] h4,' +
    'html[lang="ja"] h5,' +
    'html[lang="ja"] h6,' +
    'html[lang="ja"] button,' +
    'html[lang="ja"] .button{' +
      'font-family:"ヒラギノ角ゴ Pro W6","ヒラギノ角ゴ W6","Hiragino Kaku Gothic Pro W6",YuGothic,"游ゴシック",Meiryo,"メイリオ","ＭＳ Ｐゴシック","MS PGothic",sans-serif!important;' +
      'font-weight:700;' +
    '}';

  document.head.appendChild(style);
}());


(function () {
  if (document.getElementById('karuno-en-garage-font')) {
    return;
  }

  var style = document.createElement('style');
  style.id = 'karuno-en-garage-font';
  style.textContent =
    '@font-face{' +
      'font-family:Poppins;font-weight:600;font-style:normal;font-display:swap;' +
      'src:url("/cdn/fonts/poppins/poppins_n6.aa29d4918bc243723d56b59572e18228ed0786f6.woff2") format("woff2"),' +
      'url("/cdn/fonts/poppins/poppins_n6.5f815d845fe073750885d5b7e619ee00e8111208.woff") format("woff");' +
    '}' +
    '@font-face{' +
      'font-family:Poppins;font-weight:600;font-style:italic;font-display:swap;' +
      'src:url("/cdn/fonts/poppins/poppins_i6.bb8044d6203f492888d626dafda3c2999253e8e9.woff2") format("woff2"),' +
      'url("/cdn/fonts/poppins/poppins_i6.e233dec1a61b1e7dead9f920159eda42280a02c3.woff") format("woff");' +
    '}' +
    'html[lang="en"]{' +
      '--heading-font-family:Barlow,sans-serif!important;' +
      '--heading-font-weight:600;' +
      '--text-font-family:Barlow,sans-serif!important;' +
      '--text-font-weight:500;' +
      '--text-font-bolder-weight:600;' +
    '}' +
    'html[lang="en"] body,' +
    'html[lang="en"] button,' +
    'html[lang="en"] input,' +
    'html[lang="en"] select,' +
    'html[lang="en"] textarea{' +
      'font-family:Barlow,sans-serif!important;' +
    '}' +
    'html[lang="en"] .heading,' +
    'html[lang="en"] h1,' +
    'html[lang="en"] h2,' +
    'html[lang="en"] h3,' +
    'html[lang="en"] h4,' +
    'html[lang="en"] h5,' +
    'html[lang="en"] h6{' +
      'font-family:Barlow,sans-serif!important;' +
      'font-weight:600;' +
    '}';

  document.head.appendChild(style);
}());


(function () {
  if (window.karunoGalleryThumbnailSyncV2) {
    window.karunoGalleryThumbnailSyncV2();
    return;
  }

  var observedWrappers = new WeakSet();
  var wheelBoundLists = new WeakSet();

  function clearGalleryStyles(gallery) {
    var thumbnailList = gallery.querySelector('.product-gallery__thumbnail-list');
    var scrollerInner = thumbnailList && thumbnailList.closest('.scroller__inner');
    var scroller = thumbnailList && thumbnailList.closest('.scroller');

    if (scroller) {
      ['height', 'max-height', 'margin-top', 'margin-bottom', 'overflow', 'align-self'].forEach(function (property) {
        scroller.style.removeProperty(property);
      });
    }

    if (scrollerInner) {
      ['height', 'max-height', 'overflow'].forEach(function (property) {
        scrollerInner.style.removeProperty(property);
      });
    }

    if (thumbnailList) {
      [
        'height',
        'max-height',
        'margin-top',
        'margin-bottom',
        'overflow-x',
        'overflow-y',
        'overscroll-behavior-y',
        'touch-action',
        '-webkit-overflow-scrolling',
        'clip-path',
        'scrollbar-width'
      ].forEach(function (property) {
        thumbnailList.style.removeProperty(property);
      });
    }
  }

  function bindWheel(thumbnailList) {
    if (wheelBoundLists.has(thumbnailList)) {
      return;
    }

    thumbnailList.addEventListener('wheel', function (event) {
      var maxScroll = thumbnailList.scrollHeight - thumbnailList.clientHeight;

      if (maxScroll <= 1) {
        return;
      }

      var delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
      var canScrollUp = delta < 0 && thumbnailList.scrollTop > 0;
      var canScrollDown = delta > 0 && thumbnailList.scrollTop < maxScroll;

      if (canScrollUp || canScrollDown) {
        event.preventDefault();
        event.stopPropagation();
        thumbnailList.scrollTop += delta;
      }
    }, { passive: false });

    wheelBoundLists.add(thumbnailList);
  }

  function syncGallery(gallery) {
    var thumbnailList = gallery.querySelector('.product-gallery__thumbnail-list');
    var carouselWrapper = gallery.querySelector('.product-gallery__carousel-wrapper');

    if (!thumbnailList || !carouselWrapper) {
      return;
    }

    clearGalleryStyles(gallery);

    var scrollerInner = thumbnailList.closest('.scroller__inner');
    var scroller = thumbnailList.closest('.scroller');
    var galleryRect = gallery.getBoundingClientRect();
    var carouselRect = carouselWrapper.getBoundingClientRect();
    var thumbnailRect = thumbnailList.getBoundingClientRect();
    var flexDirection = window.getComputedStyle(gallery).flexDirection;
    var isVerticalRail = (flexDirection === 'row' || flexDirection === 'row-reverse') &&
      carouselRect.left > thumbnailRect.left + (thumbnailRect.width * 0.75) &&
      carouselRect.width > thumbnailRect.width * 1.5;

    if (!isVerticalRail || !scroller || !scrollerInner) {
      return;
    }

    var topOffset = Math.max(0, carouselRect.top - galleryRect.top);
    var carouselHeight = Math.max(1, carouselRect.height);

    scroller.style.height = carouselHeight + 'px';
    scroller.style.maxHeight = carouselHeight + 'px';
    scroller.style.marginTop = topOffset + 'px';
    scroller.style.marginBottom = '0px';
    scroller.style.overflow = 'hidden';
    scroller.style.alignSelf = 'flex-start';

    scrollerInner.style.height = '100%';
    scrollerInner.style.maxHeight = '100%';
    scrollerInner.style.overflow = 'hidden';

    thumbnailList.style.height = '100%';
    thumbnailList.style.maxHeight = '100%';
    thumbnailList.style.marginTop = '0px';
    thumbnailList.style.marginBottom = '0px';
    thumbnailList.style.overflowX = 'hidden';
    thumbnailList.style.overflowY = 'auto';
    thumbnailList.style.overscrollBehaviorY = 'contain';
    thumbnailList.style.touchAction = 'pan-y';
    thumbnailList.style.webkitOverflowScrolling = 'touch';
    thumbnailList.style.clipPath = 'inset(0)';
    thumbnailList.style.scrollbarWidth = 'none';

    bindWheel(thumbnailList);
  }

  function syncAllGalleries() {
    document.querySelectorAll('.product-gallery--with-thumbnails').forEach(function (gallery) {
      syncGallery(gallery);

      var carouselWrapper = gallery.querySelector('.product-gallery__carousel-wrapper');

      if (carouselWrapper && !observedWrappers.has(carouselWrapper) && window.ResizeObserver) {
        new ResizeObserver(function () {
          window.requestAnimationFrame(function () {
            syncGallery(gallery);
          });
        }).observe(carouselWrapper);

        observedWrappers.add(carouselWrapper);
      }
    });
  }

  function queueSync() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(syncAllGalleries);
    });
  }

  window.karunoGalleryThumbnailSync = syncAllGalleries;
  window.karunoGalleryThumbnailSyncV2 = syncAllGalleries;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync, { once: true });
  } else {
    queueSync();
  }

  window.addEventListener('load', queueSync, { once: true });
  window.addEventListener('resize', queueSync, { passive: true });
  document.addEventListener('variant:changed', queueSync);
  document.addEventListener('product:rerender', queueSync);
}());

/* KARUNO PRODUCT SHIPPING NOTICE + ACCORDION */
(function () {
  var styleId = 'karuno-product-shipping-modules-style';
  var noticeId = 'karuno-us-customer-note';
  var shippingId = 'karuno-product-shipping-information';

  var copy = {
    en: {
      noteTitle: 'Note for US customers:',
      noteText: 'Due to current U.S. tariff policy, all carriers require duties to be prepaid for U.S.-bound shipments. Based on the items in your order, we will send you a separate invoice showing the duty amount required by the carrier and collect payment before shipment.',
      shippingTitle: 'Shipping information',
      processing: 'Orders are usually processed within 3–5 business days. Standard delivery normally takes 5–10 business days from the order date; pre-orders are generally dispatched in about 20 days. International delivery may take longer depending on the carrier and destination customs clearance.',
      calculation: 'Shipping charges are based on the destination and SF Express billed weight, using the greater of actual weight or volumetric weight. Applicable carrier surcharges may also be included.',
      duties: 'Duties, import taxes, customs-clearance and brokerage fees are not included and must be paid by the recipient upon delivery.',
      link: 'View full shipping rates and information'
    },
    zh: {
      shippingTitle: '配送資訊',
      processing: '訂單通常會在 3–5 個工作天內處理。標準配送一般會在下單日起 5–10 個工作天內送達；預購商品通常約 20 天後寄出。國際配送時間可能因承運商及目的地清關安排而延長。',
      calculation: '運費會按目的地及順豐計費重量計算，實際重量與體積重量取較高者，並可能包括適用的承運商附加費。',
      duties: '關稅、進口稅、清關費及報關代理費不包含在內，須由收件人在派送時自行支付。',
      link: '查看完整運費及配送資訊'
    },
    ja: {
      shippingTitle: '配送情報',
      processing: '通常、ご注文は3～5営業日以内に処理されます。通常配送はご注文日から5～10営業日でのお届けが目安です。予約商品は通常、約20日後に発送されます。国際配送は、配送会社の輸送状況やお届け先の通関手続きにより、さらに時間がかかる場合があります。',
      calculation: '送料は配送先とSF Expressの請求重量に基づいて計算され、実重量と容積重量のうち大きい方が適用されます。また、該当する配送会社の追加料金が含まれる場合があります。',
      duties: '関税、輸入税、通関手数料および通関代行手数料は含まれておらず、配達時に受取人にてお支払いいただきます。',
      link: '送料・配送情報の詳細を見る'
    }
  };

  function localeKey() {
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    if (lang.indexOf('ja') === 0) return 'ja';
    if (lang.indexOf('zh') === 0) return 'zh';
    return 'en';
  }

  function ensureStyle() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent =
      '#' + noticeId + '{background:#fff3cd;border:1px solid #ffeeba;padding:14px 18px;line-height:1.65;color:var(--text-color);}' +
      '#' + noticeId + ' strong{font-weight:700;}' +
      '.product-block-list__wrapper>#' + noticeId + '+.product-block-list__item--description{margin-top:0!important;}' +
      '#' + shippingId + ' .karuno-shipping-card{overflow:hidden;}' +
      '#' + shippingId + ' summary{list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:20px;padding:20px 30px;font-weight:600;}' +
      '#' + shippingId + ' summary::-webkit-details-marker{display:none;}' +
      '#' + shippingId + ' .karuno-shipping-plus{position:relative;display:block;flex:0 0 16px;width:16px;height:16px;}' +
      '#' + shippingId + ' .karuno-shipping-plus:before,#' + shippingId + ' .karuno-shipping-plus:after{content:"";position:absolute;left:0;top:7px;width:16px;height:2px;background:currentColor;transition:transform .2s ease;}' +
      '#' + shippingId + ' .karuno-shipping-plus:after{transform:rotate(90deg);}' +
      '#' + shippingId + ' details[open] .karuno-shipping-plus:after{transform:rotate(0);}' +
      '#' + shippingId + ' .karuno-shipping-content{padding:0 30px 24px;line-height:1.7;}' +
      '#' + shippingId + ' .karuno-shipping-content p{margin:0 0 14px;}' +
      '#' + shippingId + ' .karuno-shipping-content p:last-of-type{margin-bottom:16px;}' +
      '#' + shippingId + ' .karuno-shipping-link{font-weight:600;text-decoration:underline;text-underline-offset:3px;}' +
      '@media(max-width:640px){.product-block-list__wrapper:has(>#' + noticeId + ')>.product-block-list__item--gallery .card{margin-bottom:0!important;}#' + noticeId + '{padding:12px 15px;margin-top:0!important;margin-bottom:0!important;}#' + noticeId + '+.product-block-list__item--info>.card{margin-top:0!important;border-top:0;}#' + noticeId + '+.product-block-list__item--info>.card>.card__section{padding-top:18px;}#' + shippingId + ' summary{padding:18px 20px;}#' + shippingId + ' .karuno-shipping-content{padding:0 20px 21px;}}';

    document.head.appendChild(style);
  }

  function makeNotice(t) {
    var notice = document.createElement('div');
    notice.id = noticeId;
    notice.className = 'product-block-list__item karuno-us-customer-note';
    notice.setAttribute('role', 'note');

    var strong = document.createElement('strong');
    strong.textContent = t.noteTitle;
    notice.appendChild(strong);
    notice.appendChild(document.createTextNode(' ' + t.noteText));

    return notice;
  }

  function makeShipping(t) {
    var item = document.createElement('div');
    item.id = shippingId;
    item.className = 'product-block-list__item product-block-list__item--content karuno-product-shipping-information';

    var details = document.createElement('details');
    details.className = 'card karuno-shipping-card';

    var summary = document.createElement('summary');
    summary.innerHTML = '<span class="card__title heading h3"></span><span class="karuno-shipping-plus" aria-hidden="true"></span>';
    summary.querySelector('.card__title').textContent = t.shippingTitle;

    var content = document.createElement('div');
    content.className = 'karuno-shipping-content rte';
    [t.processing, t.calculation, t.duties].forEach(function (text) {
      var p = document.createElement('p');
      p.textContent = text;
      content.appendChild(p);
    });

    var link = document.createElement('a');
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    link.href = root + 'pages/shipping-rates-surcharges';
    link.className = 'karuno-shipping-link';
    link.textContent = t.link;
    content.appendChild(link);

    details.appendChild(summary);
    details.appendChild(content);
    item.appendChild(details);

    return item;
  }

  function setupProductShippingModules() {
    var wrapper = document.querySelector('.product-block-list__wrapper');
    var gallery = wrapper && wrapper.querySelector('.product-block-list__item--gallery');
    var description = wrapper && wrapper.querySelector('.product-block-list__item--description');
    if (!wrapper || !gallery || !description) return;

    ensureStyle();

    var locale = localeKey();
    var t = copy[locale];
    var existingNotice = document.getElementById(noticeId);
    var existingShipping = document.getElementById(shippingId);
    if (existingNotice) existingNotice.remove();
    if (existingShipping) existingShipping.remove();

    if (locale === 'en') {
      gallery.insertAdjacentElement('afterend', makeNotice(t));
    }
    description.insertAdjacentElement('afterend', makeShipping(t));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupProductShippingModules, { once: true });
  } else {
    setupProductShippingModules();
  }

  document.addEventListener('shopify:section:load', setupProductShippingModules);
  document.addEventListener('product:rerender', setupProductShippingModules);
}());

/* KARUNO PRODUCT STICKY HEADER LINK — frame-synced */
(function () {
  var headerSelector = '.shopify-section__header';
  var stickySelector = '.product-block-list__item--info .card--sticky';
  var headerObserver;
  var stickyObserver;
  var observedHeader;
  var observedStickies = [];
  var animationFrame = 0;
  var syncUntil = 0;

  function getStickies() {
    return Array.prototype.slice.call(document.querySelectorAll(stickySelector));
  }

  function restoreMobile(stickies) {
    stickies.forEach(function (sticky) {
      if (sticky.getAttribute('data-karuno-sticky-managed') !== 'true') return;

      sticky.style.removeProperty('top');
      sticky.style.removeProperty('transition');
      sticky.removeAttribute('data-karuno-sticky-managed');
    });
  }

  function currentTopValue() {
    var header = document.querySelector(headerSelector);
    if (!header) return '15px';

    var headerBottom = header.getBoundingClientRect().bottom;
    return Math.max(15, headerBottom + 15).toFixed(2) + 'px';
  }

  function setPositions() {
    var stickies = getStickies();

    if (window.innerWidth < 1000) {
      restoreMobile(stickies);
      observeStickies(stickies);
      return;
    }

    var topValue = currentTopValue();

    stickies.forEach(function (sticky) {
      if (
        sticky.style.getPropertyValue('top') !== topValue ||
        sticky.style.getPropertyPriority('top') !== 'important'
      ) {
        sticky.style.setProperty('top', topValue, 'important');
      }

      if (
        sticky.style.getPropertyValue('transition') !== 'none' ||
        sticky.style.getPropertyPriority('transition') !== 'important'
      ) {
        sticky.style.setProperty('transition', 'none', 'important');
      }

      sticky.setAttribute('data-karuno-sticky-managed', 'true');
    });

    observeStickies(stickies);
  }

  function runAnimationFrame(timestamp) {
    animationFrame = 0;
    setPositions();

    if (timestamp < syncUntil) {
      animationFrame = window.requestAnimationFrame(runAnimationFrame);
    }
  }

  function startFrameSync(duration) {
    syncUntil = Math.max(syncUntil, performance.now() + (duration || 0));
    setPositions();

    if (!animationFrame) {
      animationFrame = window.requestAnimationFrame(runAnimationFrame);
    }
  }

  function observeStickies(stickies) {
    var changed =
      stickies.length !== observedStickies.length ||
      stickies.some(function (sticky, index) {
        return sticky !== observedStickies[index];
      });

    if (!changed) return;

    if (stickyObserver) stickyObserver.disconnect();
    observedStickies = stickies;

    stickyObserver = new MutationObserver(function () {
      setPositions();
    });

    observedStickies.forEach(function (sticky) {
      stickyObserver.observe(sticky, {
        attributes: true,
        attributeFilter: ['style']
      });
    });
  }

  function setupHeaderLink() {
    var header = document.querySelector(headerSelector);
    if (!header || !document.querySelector(stickySelector)) return;

    if (observedHeader !== header) {
      if (headerObserver) headerObserver.disconnect();
      observedHeader = header;

      headerObserver = new MutationObserver(function () {
        startFrameSync(400);
      });

      headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    startFrameSync(80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHeaderLink, { once: true });
  } else {
    setupHeaderLink();
  }

  window.addEventListener('scroll', function () {
    startFrameSync(80);
  }, { passive: true });

  window.addEventListener('resize', function () {
    startFrameSync(500);
  }, { passive: true });

  document.addEventListener('shopify:section:load', setupHeaderLink);
  document.addEventListener('product:rerender', setupHeaderLink);
}());

/* KARUNO OMM FINAL SALE NOTICE */
(function () {
  var noticeId = 'karuno-omm-final-sale-notice';
  var styleId = 'karuno-omm-final-sale-style';
  var labels = {
    en: 'FINAL SALE: All OMM products are final sale.',
    zh: '最終銷售：所有 OMM 商品均屬最終銷售。',
    ja: 'ファイナルセール：OMMの商品はすべてファイナルセールです。'
  };

  function localeKey() {
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    if (lang.indexOf('ja') === 0) return 'ja';
    if (lang.indexOf('zh') === 0) return 'zh';
    return 'en';
  }

  function ensureStyle() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent =
      '#' + noticeId + '{margin:0 0 18px;color:var(--accent-color,#a85f42);font-weight:700;letter-spacing:.02em;}';
    document.head.appendChild(style);
  }

  function syncFinalSaleNotice() {
    var vendor = document.querySelector('.product-meta__vendor');
    var description = document.querySelector('.product-block-list__item--description .rte.text--pull');
    var existing = document.getElementById(noticeId);
    var isOmm = vendor && vendor.textContent.trim().toUpperCase() === 'OMM';

    if (!isOmm || !description) {
      if (existing) existing.remove();
      return;
    }

    ensureStyle();

    if (!existing) {
      existing = document.createElement('p');
      existing.id = noticeId;
      existing.setAttribute('role', 'note');
    }

    existing.textContent = labels[localeKey()];
    if (description.firstChild !== existing) {
      description.insertBefore(existing, description.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFinalSaleNotice, { once: true });
  } else {
    syncFinalSaleNotice();
  }

  window.addEventListener('load', syncFinalSaleNotice, { once: true });
  document.addEventListener('variant:changed', syncFinalSaleNotice);
  document.addEventListener('product:rerender', syncFinalSaleNotice);
  document.addEventListener('shopify:section:load', syncFinalSaleNotice);
}());


/* KARUNO ABOUT US FOOTER GAP FIX */
(function () {
  if (document.getElementById('karuno-about-us-footer-gap-fix')) {
    return;
  }

  var style = document.createElement('style');
  style.id = 'karuno-about-us-footer-gap-fix';
  style.textContent = '#shopify-section-template--25371844313375__custom_liquid_djT6Ef>.section{margin:0!important;}';
  document.head.appendChild(style);
}());